import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-loader',
    templateUrl: './hx-loader.component.html',
    styleUrls: ['./hx-loader.component.css'],
    imports: [NgIf, TranslocoPipe]
})
export class HxLoaderComponent {
  @Input() isLoading = false;
  @Input() length = 0;

  constructor() { }

}
